var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-button',{attrs:{"slot":"start","fill":"clear","size":"small"},on:{"click":_vm.signout},slot:"start"},[_vm._v("Sign Out")])}
var staticRenderFns = []

export { render, staticRenderFns }